import { EventViewData } from 'components/eventView/pages/eventData';

export const UtrechtEvent: EventViewData = {
    eventId: 'utrecht-careers-day-2024',
    mapId: '10dd4d29-d2ef-40c7-9ed0-8e94ba3e8ef6',
    guideId: '753891cd-da20-4d83-8cc9-c288316463f2',
    mapSettings: {
        standZoom: 0.6
    }
};
